/* eslint-disable react/jsx-props-no-spreading */
import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";
import Dashboard from "./Dashboard/Dashboard";
import { getFormattedData } from "./utils";
import FriendDetailCard from "./FriendDetailCards/DetailCards";
import Friends from "../../../../services/api/friend";
import useUserConfig from "../../../../hooks/useUserConfig";
import Loader from "../../../../components/common/Loader/Loader";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#F7F7F9",
    paddingBottom: "5px",
    margin: "0 -2%",
  },
};

function FriendDetail() {
  const TITLE = "Friend Details - BSG";
  const [friendInfo, setFriendInfo] = useState({});
  const [attendanceInfo, setAttendanceInfo] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const { id } = useParams();
  const hasPermission = useUserConfig();

  const fetchFriendData = async (friendId) => {
    try {
      setIsLoading(true);
      const promiseAPIs = [
        Friends.friendView(friendId),
        Friends.getAttendanceByFriendId(friendId),
      ];
      const [friendInfoData, attendanceData] = await Promise.all(promiseAPIs);

      setFriendInfo(friendInfoData.data);
      setAttendanceInfo(getFormattedData(attendanceData.data));
      setIsLoading(false);
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchFriendData(id);
    }
  }, [id]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 10000);
    return () => clearTimeout(timer);
  }, []);

  const breadcrumbs = [
    friendInfo?.areaName,
    friendInfo?.clusterName,
    friendInfo?.zoneName,
    friendInfo?.regionName,
    friendInfo?.chapterName,
    friendInfo?.districtName,
    friendInfo?.blockName,
  ]
    .filter(Boolean)
    .join(" > ");

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <Box style={styles.container}>
        <FriendDetailCard
          friendInfo={friendInfo}
          hasPermission={hasPermission}
          breadcrumbs={breadcrumbs}
        />

        <Box>
          <Dashboard
            friendId={friendInfo.friendId}
            attendanceInfo={attendanceInfo}
            friendInfo={friendInfo}
          />
        </Box>

        {isLoading && <Loader />}
      </Box>
    </>
  );
}

export default FriendDetail;
